@let stockTotals = stockStore.vm().stockFuelTotals;
@let numFuelTypesCols = stockTotals?.size ?? 0;

@if (numFuelTypesCols > 0) {
  <div
    class="mt-5 grid justify-center gap-x-2"
    style="grid-template-rows: auto auto"
    [style.gridTemplateColumns]="
      'repeat(' + (numFuelTypesCols + 1) + ', minmax(57px, 150px))'
    "
  >
    <div class="row-span-2 flex items-end font-semibold">Total stock</div>

    @for (item of stockTotals; track $index) {
      <div
        class="text-center font-medium"
        [attr.id]="`fuel-type-header-${$index}`"
        [attr.data-testid]="`fuel-type-header-${$index}`"
      >
        {{ item[0] | uppercase }}
      </div>
    }

    @for (item of stockTotals; track $index) {
      <nsp-number-input
        [id]="`${$index}`"
        [name]="`${$index}`"
        [ngModel]="item[1]"
        [readonly]="true"
        class="w-full"
        [unit]="'MT'"
      >
      </nsp-number-input>
    }
  </div>
}
